<ng-container
  *ngIf="
    (enabled$ | async) &&
    (isPersistent || (isOpen$ | async) || panelClosing)
  "
>
  <div
    class="side-nav"
    [class.side-nav--open]="isPersistent || panelOpen"
    [class.side-nav--closing]="!isPersistent && panelClosing"
    [class.side-nav--persistent]="isPersistent"
    [attr.role]="isPersistent ? null : 'dialog'"
    [attr.aria-modal]="isPersistent ? null : true"
    [attr.aria-label]="isPersistent ? null : 'Navigation menu'"
  >
    <div
      class="side-nav__backdrop"
      (click)="onBackdropClick()"
      aria-hidden="true"
    ></div>

    <aside
      #panelRoot
      class="side-nav__panel"
      [class.side-nav__panel--dragging]="panelDragging"
      [style.transform]="panelDragTransform"
      (touchstart)="onPanelTouchStart($event)"
      (touchmove)="onPanelTouchMove($event)"
      (touchend)="onPanelTouchEnd()"
      (touchcancel)="onPanelTouchEnd()"
    >
      <header class="side-nav__header">
        <div class="side-nav__logo" aria-hidden="true">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1920 1080"
            focusable="false"
          >
            <path
              class="side-nav__logo-path"
              d="M108.26,346.89h284.06v55.51h-223.82v106.3h189.57v55.51h-189.57v113.39h223.82v55.51H108.26v-386.23Z"
            />
            <path
              class="side-nav__logo-path"
              d="M869.91,515.24c0-115.03,67.04-168.36,155.41-168.36,57.9,0,106.65,25.9,132.55,74.66,25.9-48.75,73.9-74.66,132.55-74.66,88.37,0,155.41,53.33,155.41,168.36v217.87h-72.37v-217.87c0-70.09-37.33-101.32-89.89-101.32s-89.13,32.76-89.13,101.32v217.87h-72.37v-217.87c0-68.56-38.85-101.32-89.89-101.32s-89.89,31.23-89.89,101.32v217.87h-72.37v-217.87Z"
            />
            <path
              class="side-nav__logo-path"
              d="M1499.94,580.16c0-88.24,64.71-152.95,156.48-152.95s155.31,64.71,155.31,152.95v20.59h-252.96c8.24,51.77,47.06,80.6,97.66,80.6,37.65,0,64.12-11.77,81.18-37.06h61.77c-22.36,54.12-75.3,88.83-142.95,88.83-91.77,0-156.48-64.71-156.48-152.95ZM1752.91,550.75c-11.18-46.47-49.42-71.77-96.48-71.77s-84.71,25.88-95.89,71.77h192.37Z"
            />
            <polygon
              class="side-nav__logo-path"
              points="663.99 580.29 663.99 427.21 815.66 427.21 663.99 580.29"
            />
            <polygon
              class="side-nav__logo-path"
              points="446.5 427.21 599.42 580.13 446.43 733.11 511.16 733.11 663.99 580.29 510.9 427.21 446.5 427.21"
            />
            <polygon
              class="side-nav__logo-path"
              points="663.99 580.29 663.99 733.11 815.66 733.11 663.99 580.29"
            />
          </svg>
        </div>

        <button
          *ngIf="!isAnonymous"
          type="button"
          class="side-nav__avatar-btn"
          (click)="onProfileClick()"
          [attr.aria-label]="'PREFERENCES_PAGE' | translate"
        >
          <span class="side-nav__avatar-ring" aria-hidden="true"></span>
          <img
            class="side-nav__avatar-img"
            [src]="userAvatar"
            alt=""
            onerror="if (this.src != 'assets/icon/noavatar.svg;') this.src = '/assets/icon/New-Icons/No-Avatar.svg';"
          />
        </button>

        <ion-button
          *ngIf="isAnonymous"
          class="side-nav__login-btn"
          (click)="onLoginClick()"
        >
          {{ 'LOGIN' | translate }}
          <ion-icon slot="end" name="log-in-outline" aria-hidden="true"></ion-icon>
        </ion-button>
      </header>

      <div class="side-nav__body">
        <nav class="side-nav__sheet" aria-label="Main navigation">
          <ng-container *ngFor="let p of pages; let i = index">
            <button
              *ngIf="!p.hide"
              type="button"
              class="side-nav__row"
              [class.side-nav__row--active]="selectedIndex === i"
              [style.--side-nav-stagger-index]="i"
              (click)="onNavigate(i)"
            >
              <app-side-nav-icon
                [svgPath]="p.svg"
                [invertColors]="isIconInverted(p.svg)"
              ></app-side-nav-icon>
              <span class="side-nav__label">{{ p.title | translate }}</span>
              <span
                *ngIf="
                  p.badgeValue !== undefined &&
                  p.badgeValue !== null &&
                  p.badgeValue !== ''
                "
                class="side-nav__badge"
              >
                {{ p.badgeValue }}
              </span>
            </button>
          </ng-container>
        </nav>
      </div>
    </aside>
  </div>
</ng-container>
